/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@dm/core';
import { CifsShareModule } from 'app/feature/service/file-service/share/cifs-share/cifs-share.module';
import { NfsShareModule } from 'app/feature/service/file-service/share/nfs-share/nfs-share.module';

import { SmartAssistantGifContainerModule } from '../gif-container/gif-container.module';
import { SmartAssistantObjectContainerModule } from '../object-container/object-container.module';
import { SmartAssistantSwitchModule } from '../smart-assistant-switch/smart-assistant-switch.module';
import { SmartAssistantFileShareComponent } from './file-share.component';
import { SmartAssistantFileShareStrService } from './file-share-str.service';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SmartAssistantGifContainerModule,
        SmartAssistantObjectContainerModule,
        CifsShareModule,
        NfsShareModule,
        SmartAssistantSwitchModule,
    ],
    declarations: [SmartAssistantFileShareComponent],
    exports: [SmartAssistantFileShareComponent],
    providers: [SmartAssistantFileShareStrService],
})
export class SmartAssistantFileShareModule { }
